import { defineCapability } from './internal';
import { args } from '../common/args';
export const TOGGLE_CSAT_SURVEY_CAP = defineCapability({
  name: 'TOGGLE_CSAT_SURVEY_CAP',
  args: {
    surveyId: args.number()
  }
});